var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"viewFooter"}},[_vm._v("© 2019. 최소원 All rights reserved")])}
var staticRenderFns = []

export { render, staticRenderFns }